export enum WidgetCategory {
  ASSESS,
  INSTRUCT,
  TUTOR
}

export enum WidgetType {
  ASSESSMENT_STATUS,
  ASSESSMENT_OUTCOMES,
  WEEKLY_PLAN,
  TUTOR_HIGHLIGHTS,
}
